import { booleanAttribute, ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { AppModal } from '@app/shared/controls/app-modal/app-modal';
import { TranslatePipe } from '@ngx-translate/core';
import { AppIcon } from "@app/shared/controls/app-icon/app-icon";

type ConfirmModalActionTone = 'primary' | 'danger';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppModal, TranslatePipe, AppIcon],
})
export class ConfirmModalComponent {

  readonly open = input(false);
  readonly title = input('app.confirmModal.defaultTitle');
  readonly titleParams = input<Record<string, unknown>>({});
  readonly message = input('app.confirmModal.defaultMessage');
  readonly messageParams = input<Record<string, unknown>>({});
  readonly confirmLabel = input('common.actions.confirm');
  readonly confirmLabelParams = input<Record<string, unknown>>({});
  readonly cancelLabel = input('app.confirmModal.cancel');
  readonly cancelLabelParams = input<Record<string, unknown>>({});
  readonly actionButtonTone = input<ConfirmModalActionTone>('primary');
  readonly actionIcon = input<string | undefined>(undefined);
  readonly modalIcon = input<string | undefined>(undefined);
  readonly requireConfirmation = input(false, { transform: booleanAttribute });
  readonly busy = input(false, { transform: booleanAttribute });
  readonly confirmationLabel = input('app.confirmModal.requireConfirmationLabel');

  readonly confirmed = output<void>();
  readonly cancelled = output<void>();

  protected readonly confirmationChecked = signal(false);
  protected readonly confirmDisabled = computed(() =>
    this.busy() || (this.requireConfirmation() && !this.confirmationChecked()),
  );

  protected onConfirmClick(): void {
    if (this.confirmDisabled()) {
      return;
    }

    this.confirmationChecked.set(false);
    this.confirmed.emit();
  }

  protected onCancelClick(): void {
    if (this.busy()) {
      return;
    }
    this.confirmationChecked.set(false);
    this.cancelled.emit();
  }

  protected onConfirmationCheckedChange(event: Event): void {
    this.confirmationChecked.set(event.target instanceof HTMLInputElement && event.target.checked);
  }
}
